'use client';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const GA_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

export function trackEvent(eventName: string, params: Record<string, any> = {}): void {
  if (typeof window === 'undefined' || !window.gtag || !GA_ID) return;
  window.gtag('event', eventName, params);
}

// RFQ-specific tracking helpers
export const rfqAnalytics = {
  /** Fired once when the user first lands on /rfq */
  formStart: () =>
    trackEvent('rfq_form_start', {
      event_category: 'RFQ',
      event_label: 'Form Started',
    }),

  /** Fired when the user successfully advances past a step */
  stepComplete: (step: number, stepName: string) =>
    trackEvent('rfq_step_complete', {
      event_category: 'RFQ',
      event_label: stepName,
      step_number: step,
      step_name: stepName,
    }),

  /** Fired when the user navigates back (potential drop-off signal) */
  stepBack: (fromStep: number, stepName: string) =>
    trackEvent('rfq_step_back', {
      event_category: 'RFQ',
      event_label: stepName,
      step_number: fromStep,
      step_name: stepName,
    }),

  /** Fired on successful form submission */
  formSubmit: (rfqReference: string, urgencyLevel: string, country: string) =>
    trackEvent('rfq_form_submit', {
      event_category: 'RFQ',
      event_label: rfqReference,
      rfq_reference: rfqReference,
      urgency_level: urgencyLevel,
      country,
    }),

  /** Fired when submission fails */
  submitError: (errorMessage: string) =>
    trackEvent('rfq_submit_error', {
      event_category: 'RFQ',
      event_label: errorMessage,
    }),
};
